<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Case of the Sliding Pool</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="ded"><span><b>For Dolly, Maxie, and George,<br/>my Three disciples at<br/>Laurel Way</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a362932e